import { Space } from 'antd';
import { format } from 'date-fns';

interface Props {
    text: any;
}

const TableDateFormatter = ({ text }: Props) => {
    const date = text ? format(new Date(text), "dd/MM/yyyy HH:mm") : '-';
    return (
        <Space size="middle">
            {date}
        </Space>
    )
}

export default TableDateFormatter;